
const FAQSection = () => {
  const faqs = [
    {
      question: '前金日間照顧中心的服務時間是什麼時候？',
      answer: '前金日間照顧中心的服務時間為週一至週五 08:00-17:00，國定假日休息。歡迎於服務時間內來電洽詢或預約參觀。',
    },
    {
      question: '前金日間照顧中心提供哪些照護服務？',
      answer: '前金日間照顧中心提供長照3.0日間照顧服務，包含失智照護、失能照護、認知訓練、健康促進活動、營養午餐與點心、個別化訓練、自立支援、沐浴服務及交通接送等完整照護方案。',
    },
    {
      question: '前金日間照顧中心的地址在哪裡？交通方便嗎？',
      answer: '前金日間照顧中心位於高雄市前金區文武二街163號5樓，鄰近前金捷運站3號出口，步行約3分鐘即可到達，交通非常便利。自行開車者附近也有收費停車場。',
    },
    {
      question: '前金日間照顧中心可以申請長照補助嗎？',
      answer: '可以的。前金日間照顧中心配合政府長照3.0政策，符合資格的長者可申請長照補助，最高補助84%。我們的專業團隊也會協助家屬辦理補助申請相關事宜。',
    },
    {
      question: '如何預約參觀前金日間照顧中心？',
      answer: '您可以透過電話 07-2416568 預約參觀，或在官網填寫預約參觀表單。建議提前3天預約，我們將安排專人為您導覽介紹中心環境與服務內容。參觀時間為週一至週五 09:00-17:00。',
    },
    {
      question: '前金日間照顧中心的服務對象有哪些？',
      answer: '前金日間照顧中心主要服務對象為失智個案及失能個案。我們擁有專業的照護團隊，針對不同長者的需求提供個別化的照護計畫，讓每位長者都能獲得最適切的照顧。',
    },
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-white to-cream-50" aria-labelledby="faq-title">
      <div className="max-w-4xl mx-auto px-6">
        <header className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-baby-blue-100 px-4 py-2 rounded-full mb-6">
            <i className="ri-question-answer-line text-baby-blue-500" aria-hidden="true"></i>
            <span className="text-sm font-medium text-baby-blue-600">常見問題</span>
          </div>
          <h2 id="faq-title" className="text-3xl md:text-4xl font-bold text-baby-blue-600 mb-4">
            <a href="#faq" className="hover:text-baby-blue-700 transition-colors">常見問題 FAQ</a>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            關於<strong>前金日間照顧中心</strong>的常見問題，如有其他疑問歡迎來電洽詢
          </p>
        </header>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow"
            >
              <summary className="flex items-center justify-between gap-4 p-6 cursor-pointer list-none">
                <h3 className="text-lg font-semibold text-baby-blue-600 pr-4">{faq.question}</h3>
                <span className="w-8 h-8 flex items-center justify-center bg-baby-blue-50 rounded-full flex-shrink-0 transition-transform group-open:rotate-45">
                  <i className="ri-add-line text-baby-blue-500" aria-hidden="true"></i>
                </span>
              </summary>
              <div className="px-6 pb-6 pt-0">
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
